import { FC } from 'react';
import { Modal, TextField } from 'melp-design/components';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'store/modal';
import { Controller, SubmitHandler, useForm } from 'react-hook-form-latest';
import { Stack } from '@mui/material';

interface Values {
  comment: string;
}

interface Props extends ModalProps {
  comment: string;
  closeModal: (
    param?: { action: 'CLOSE' } | { action: 'SAVE'; comment: string },
  ) => void;
}

export const RecognitionEditModal: FC<Props> = ({ closeModal, comment }) => {
  const { t } = useTranslation();

  const { control, handleSubmit } = useForm<Values>({
    defaultValues: {
      comment,
    },
  });

  const onSubmit: SubmitHandler<Values> = async (values) => {
    closeModal({
      action: 'SAVE',
      comment: values.comment,
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Modal.Content
        title={t('recognition.recognition')}
        actions={[
          {
            variant: 'neutral-outline',
            onClick: () => closeModal({ action: 'CLOSE' }),
            label: t('common.cancel'),
          },
          {
            variant: 'primary',
            label: t('common.save'),
            type: 'submit',
          },
        ]}
      >
        <Stack gap={2}>
          <Controller
            name="comment"
            control={control}
            render={({ field: { name, value, onChange, ref } }) => {
              return (
                <TextField
                  label={t('recognitions.form.comment.label')}
                  name={name}
                  value={value}
                  onChange={onChange}
                  required
                  ref={ref}
                />
              );
            }}
          />
        </Stack>
      </Modal.Content>
    </form>
  );
};
